// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "resource_category".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { resourceCategoryKindValues } from '@borradh-workspace/labels';
/** Response atom for the "resource_category" table (1:1 with a DB row, on the wire). */
export const resourceCategoryAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    name: z.string(),
    kind: z.enum(resourceCategoryKindValues),
    description: z.string().nullable(),
    sortOrder: z.number(),
    isActive: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    deletedAt: z.string().datetime().nullable(),
});
//# sourceMappingURL=resourceCategory.js.map